import { withRedirectUnauthorized } from '../../feature/authority/utils/withAuthority';
import AccessLogList from '../../components/settings/accessLog/AccessLogList';

const SettingsAccessLogPage = () => {
  return <AccessLogList />;
};

export default withRedirectUnauthorized('administratorManagement', SettingsAccessLogPage);
